import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logo from "../Images/Bigfreshlogo1.png";

import {
  FaFacebookF,
  FaTwitter,
  FaGooglePlusG,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaArrowRight,
} from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <footer
      style={{
        background: "linear-gradient(180deg, #0b1207, #050800)",
        color: "#fff",
      }}
    >
      <Container className="py-5">
        <Row className="gy-4">
          {/* LEFT */}
          <Col lg={4} md={6} className="text-center text-md-start">
            <img src={logo} alt="Big Fresh" style={{ height: 100 }} />

            <p className="mt-3">
              Fresh groceries, fruits & daily essentials — quality you can trust,
              delivered fast.
            </p>

            <p>
              Hello to : <span className="text-success">info@bigfresh.in</span>
            </p>
{/* 
            <div className="d-flex justify-content-center justify-content-md-start gap-3">
              <FaFacebookF />
              <FaTwitter />
              <FaGooglePlusG />
              <FaLinkedinIn />
            </div> */}
          </Col>

          {/* QUICK LINKS */}
          <Col lg={2} md={6} className="ms-auto">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled lh-lg">
              <li className="d-flex align-items-center gap-2">
                <FaArrowRight className="text-success" />
                <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
                  Home
                </span>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaArrowRight className="text-success" />
                <span
                  onClick={() => navigate("/about")}
                  style={{ cursor: "pointer" }}
                >
                  About
                </span>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaArrowRight className="text-success" />
                <span
                  onClick={() => navigate("/product")}
                  style={{ cursor: "pointer" }}
                >
                  Product
                </span>
              </li>

              <li className="d-flex align-items-center gap-2">
                <FaArrowRight className="text-success" />
                <span
                  onClick={() => navigate("/contact")}
                  style={{ cursor: "pointer" }}
                >
                  Contact
                </span>
              </li>
            </ul>
          </Col>

          {/* CONTACT */}
          <Col lg={3} md={6} className="ms-auto">
            <h6 className="fw-bold mb-3">Contact Us</h6>
            <ul className="list-unstyled lh-lg">
              <li className="d-flex gap-2">
                <FaMapMarkerAlt className="text-success" />
                1/11, GIDC, Vapi - 396191 (Gujarat)
              </li>
              <li className="d-flex gap-2">
                <FaPhoneAlt className="text-success" />
                +91 8755901970
              </li>
              {/* <li className="d-flex gap-2">
                <FaEnvelope className="text-success" />
                info@bigfresh.in
              </li> */}
              <li className="d-flex gap-2 align-items-center">
  <FaEnvelope className="text-success" />
  <a 
    href="mailto:info@bigfresh.in" 
    className="text-decoration-none text-white"
  >
    info@bigfresh.in
  </a>
</li>

            </ul>
          </Col>

          {/* COPYRIGHT */}
          <Col md={12} className="text-center mt-4">
            © 2026 Big Fresh | Developed By{" "}
            <span
              className="text-success fw-semibold"
              style={{ cursor: "pointer" }}
              onClick={() =>
                window.open("https://dectwinservices.com", "_blank")
              }
            >
              Dectwin Services Pvt Ltd
            </span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
